import { Bloomberg, CryptoDaily, Yahoo, beincrypto, coindesk, cointelegraph, ntv, partnerBga, partnerImx, partnerPolygon, partnerSpace, partnerTroy, partnerWepad, partnerline, partnerlinemobile } from "../../images/general";
import React from "react";

const Partners = () => {

  return (
    <>
      <section className="bg-[#1F2327]">
        <div className="container max-w-7xl px-4 mx-auto sm:py-24 py-16 sm:pb-24 pb-12">
          <div className="lg:flex">
            <div className="lg:w-1/2 lg:pr-8"               
            data-sal="slide-right"
              data-sal-delay="400"
              data-sal-easing="ease">
              <h3 className="sm:text-7xl text-[20px] font-cinzel text-white font-bold sm:leading-[64px] sm:mx-0 mx-auto sm:text-left text-center leading-7 max-w-3xl w-2/3 uppercase">
                Our Notable <span className="text-[#ACD6E9]">Partners</span>
              </h3>
            </div>
            <div className="lg:w-1/2 mt-6 lg:mt-0"
                        data-sal="slide-left"
                        data-sal-delay="400"
                        data-sal-easing="ease">
              <div className="grid grid-cols-3 md:grid-cols-3 lg:grid-cols-4 ">
                <div className="border border-[#4D565E] flex justify-center items-center sm:h-[180px] h-[109px] px-5">
                  <img src={partnerSpace} className=" m-auto sm:w-max w-10" />
                </div>
                <div className="border border-[#4D565E] flex justify-center items-center sm:h-[180px] h-[109px] px-5">
                  <img src={partnerTroy} className=" m-auto" />
                </div>
                <div className="border border-[#4D565E] flex justify-center items-center sm:h-[180px] h-[109px] px-5 sm:border-r-0 ">
                  <img src={partnerPolygon} className=" m-auto" />
                </div>
                <div className="border border-[#4D565E] flex justify-center items-center sm:h-[180px] h-[109px] px-5">
                  <img src={partnerImx} className=" m-auto" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <img src={partnerline} className="mx-auto sm:block hidden" />
        <img src={partnerlinemobile} className="mx-auto sm:hidden block " />
        <div className="container max-w-7xl px-4 mx-auto sm:py-20 py-11" 
                    data-sal="fade-in"
                    data-sal-delay="400"
                    data-sal-easing="ease">
          <h3 className="sm:text-[56px] text-xl font-cinzel text-white font-bold sm:leading-[48px] leading-7 sm:max-w-3xl sm:w-2/3 sm:text-left text-center uppercase sm:mb-14 mb-7">
            Featured on
          </h3>
          <div className="">
            <div className="grid grid-cols-3 md:grid-cols-3 lg:grid-cols-4 sm:place-items-stretch place-items-center gap-10">
              <div className=" flex items-center ">
                <img src={Bloomberg} className="sm:mb-0 mb-5 sm:w-max sm:h-max w-24 h-7" />
              </div>
              <div className=" flex items-center ">
                <img src={Yahoo} className="mx-auto sm:mb-0 mb-5 sm:w-max sm:h-max w-24 h-7" />
              </div>
              <div className=" flex items-center ">
                <img src={cointelegraph} className="mx-auto sm:mb-0 mb-5 sm:w-max sm:h-max w-[113.29px] h-[28.28px]" />
              </div>
              <div className=" flex items-center ">
                <img src={beincrypto} className="mx-auto sm:w-max sm:h-max w-[99px] h-[25px]" />
              </div>
              <div className=" flex items-center mr-0 sm:mr-20">
                <img src={CryptoDaily} className="mx-auto sm:w-max sm:h-max w-[133px] h-[33px]" />
              </div>
              <div className=" flex items-center justify-normal sm:justify-center">
                <img src={coindesk} className="sm:mb-0 mb-1 sm:w-max sm:h-max w-24 h-7" />
              </div>
              <div className=" flex items-center ">
                <img src={ntv} className="mx-auto sm:mb-0 mb-5 sm:w-max sm:h-max w-24 h-7" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Partners;
